<div class="dorm">
  <div class="dorm_left">
    <div class="dorm_thumb_web">
      <img width="120" height="120" alt="" class="skeleton-img">
    </div>
    <div class="dorm_thumb_mobile">
      <img width="98" height="98" alt="" class="skeleton-img">
    </div>
    <div class="dorm_details">
      <div class="dorm_name text medium truncate-1-line skeleton" style="font-size: 18px;">
      </div>
      <div class="dorm_description text light truncate-2-lines skeleton" style="font-size: 18px;">
        <p>
        </p>
      </div>
      <div class="dorm_description text light truncate-2-lines skeleton" style="font-size: 18px;">
        <p>
        </p>
      </div>
      <div class="dorm_amenities dorm_amenities_web text xsmall">
        <div style="display: flex; align-items: center" class="skeleton">
        </div>
        <div style="display: flex; align-items: center;" class="skeleton">
        </div>
        <div style="display: flex; align-items: center;" class="skeleton">
        </div>
        <div style="display: flex; align-items: center;" class="skeleton">
        </div>
      </div>
    </div>
  </div>
  <div class="dorm_amenities dorm_amenities_mobile text xsmall">
    <div style="display: flex; align-items: center" class="skeleton">
    </div>
    <div style="display: flex; align-items: center;" class="skeleton">
    </div>
    <div style="display: flex; align-items: center;" class="skeleton">
    </div>
    <div style="display: flex; align-items: center;" class="skeleton">
    </div>
  </div>
  <div class="dorm_right">
    <div class="top">
      <div class="dorm_price">
        <div class="text light" style="font-size: 15px">
          <!-- from -->
        </div>
        <div class="subheader">
          <!-- {{ (room?.rates?.nonRefundable.price || room?.rates?.standard.price) | currency : c.code }} -->
        </div>
        <div class="text light flex" style="font-size: 15px">
          <div class="dot_after">
            <!-- {{ room?.roomType === 1 ? 'per bed' : 'per room' }} -->
          </div>
          <div>
            <!-- per night -->
          </div>
        </div>
      </div>
      <div class="add_rooms">
      </div>
    </div>
  </div>
</div>
